import React from 'react';
import styled from 'styled-components';
import {
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Divider
} from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import CardTitle from '../../../common/card/CardTitle';

const StyledCardTitle = styled(CardTitle)`
  margin-bottom: 10px;
`;

const StyleTableHead = styled(TableHead)`
  text-transform: uppercase;
`;

export interface JiraPeopleCardProps {
  issue: any;
}

const JiraPeopleCard: React.FC<JiraPeopleCardProps> = ({ issue }) => {
  const reporter = issue.fields.reporter?.displayName;
  const techLead = 'Unassigned';
  const productLead = 'Unassigned';
  const assignee = issue.fields.assignee?.displayName || 'Unassigned';
  const stakeholders = issue.fields?.customfield_10046 || [];

  return (
    <Card>
      <StyledCardTitle>
        <AccountCircleIcon />
        People
      </StyledCardTitle>
      <Divider />
      <Table>
        <StyleTableHead>
          <TableRow>
            <TableCell>Role</TableCell>
            <TableCell>Name</TableCell>
          </TableRow>
        </StyleTableHead>
        <TableBody>
          <TableRow>
            <TableCell>Author</TableCell>
            <TableCell>{reporter}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Assignee</TableCell>
            <TableCell>{assignee}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Tech Lead</TableCell>
            <TableCell>{techLead}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Product Lead</TableCell>
            <TableCell>{productLead}</TableCell>
          </TableRow>
          {stakeholders.length !== 0 && (
            <TableRow>
              <TableCell>Stakeholder(s)</TableCell>
              <TableCell>
                {stakeholders.map((stakeholder: any, index: number) =>
                  stakeholders.length === index + 1
                    ? stakeholder.displayName
                    : stakeholder.displayName + ', '
                )}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Card>
  );
};

export default JiraPeopleCard;
